submitSalesmanDiscount();

(function() {
    var longProductAcceptTermsButton = $('#long-product-accept-terms');
    var cartCheckout = $('#cartCheckout');
    var postCodeFormOffset = $("#postcodeform").offset();
    var offset = 0;

    if (typeof postCodeFormOffset !== 'undefined') {
        offset = postCodeFormOffset.top;
    }
    if (longProductAcceptTermsButton.length > 0) {
        cartCheckout.hide();

        longProductAcceptTermsButton.on('click', function() {
            cartCheckout.show();
            longProductAcceptTermsButton.hide();
        });
    }

    $('.cart-product__showDetails').on('click', function() {
        $(this).parent().find('.cart-product__details').toggleClass('--visible');
        $(this).toggleClass('--hidden');
        $(this).parent().find('.cart-product__hideDetails').toggleClass('--hidden');

    });
    $('.cart-product__hideDetails').on('click', function() {
        $(this).parent().find('.cart-product__details').toggleClass('--visible');
        $(this).toggleClass('--hidden');
        $(this).parent().find('.cart-product__showDetails').toggleClass('--hidden');
    });

    $('.cart-product__submit-quantity-input').on('keyup input change', function() {
        var dataId = $(this).data('id');
        $(`.cart-product__submit-quantity-button[data-id="${dataId}"`).addClass('--visible');
    });

    $('.cart-product__submit-quantity-decrement-btn').on('click', function() {
        let input = $(this).siblings().find('.cart-product__submit-quantity-input');
        let quantity = (input.val()) - 1;
        quantity = (quantity <= 0) ? 1 : quantity;
        input.val(quantity);
        $(`.cart-product__submit-quantity-button[data-id="${input.data('id')}"`).addClass('--visible');
    });

    $('.cart-product__submit-quantity-increment-btn').on('click', function() {
        let input = $(this).siblings().find('.cart-product__submit-quantity-input');
        let quantity = input.val();
        input.val(++quantity);
        $(`.cart-product__submit-quantity-button[data-id="${input.data('id')}"`).addClass('--visible');
    });

    $(".cart__proceed_checkout_button").click(function() {
        $([document.documentElement, document.body]).animate({
            scrollTop: offset
        }, 700);
    });
})();

$(function() {
    var cartSwitchButton = $('#cart-switch-checkout');
    var klarnaCheckout = $('#cart-klarna-checkout');
    var manualCheckout = $('#cart-manual-checkout');
    var checkoutPostcode = $('#checkout-postcode-form');
    var copyInvoiceDataToDelivery = $('#cart-copy-invoice-data');
    var shippingOptionsSelect = $('#cart-delivery-select');
    var errorDelivery = $('#error-delivery');
    var submit = $('#manual-order-purchase-submit');
    var exportClient = $('.export-client');
    var openLoginModal = $('#cart-login-modal__open');
    var openOfferModal = $('#cart-offer-modal__open');
    var closeLoginModal = $('#cart-login-modal__close');
    var closeOfferModal = $('#cart-offer-modal__close');

    var invoiceEmail = $('#cart-manual-order-invoice-email');
    var invoiceFirstname = $('#cart-manual-order-invoice-firstname');
    var invoiceSurname = $('#cart-manual-order-invoice-surname');
    var invoicePhone = $('#cart-manual-order-invoice-phone');
    var invoiceOrgnumber = $('#cart-manual-order-invoice-orgnumber');
    var invoicePostCode = $('#cart-manual-order-invoice-postcode');
    var invoiceStreet = $('#cart-manual-order-invoice-street');
    var invoiceStreet2 = $('#cart-manual-order-invoice-street2');
    var invoiceCity = $('#cart-manual-order-invoice-city');

    var deliveryEmail = $('#cart-manual-order-delivery-email');
    var deliveryFirstname = $('#cart-manual-order-delivery-firstname');
    var deliverySurname = $('#cart-manual-order-delivery-surname');
    var deliveryPhone = $('#cart-manual-order-delivery-phone');
    var deliveryOrgnumber = $('#cart-manual-order-delivery-orgnumber');
    var deliveryPostCode = $('#cart-manual-order-delivery-postcode');
    var deliveryStreet = $('#cart-manual-order-delivery-street');
    var deliveryStreet2 = $('#cart-manual-order-delivery-street2');
    var deliveryCity = $('#cart-manual-order-delivery-city');

    cartSwitchButton.on('click', function() {
        if (klarnaCheckout.is(':visible')) {
            klarnaCheckout.hide();
        } else {
            klarnaCheckout.show();
        }
        if (manualCheckout.is(':visible')) {
            manualCheckout.hide();
        } else {
            manualCheckout.show();
        }
        if (checkoutPostcode.is(':visible')) {
            checkoutPostcode.hide();
        } else {
            checkoutPostcode.show();
        }

    });

    copyInvoiceDataToDelivery.on('click', function(event) {
        event.preventDefault();
        deliveryEmail.val(invoiceEmail.val());
        deliveryFirstname.val(invoiceFirstname.val());
        deliverySurname.val(invoiceSurname.val());
        deliveryPhone.val(invoicePhone.val());
        deliveryOrgnumber.val(invoiceOrgnumber.val());
        deliveryPostCode.val(invoicePostCode.val()).trigger('change');
        deliveryStreet.val(invoiceStreet.val());
        deliveryStreet2.val(invoiceStreet2.val());
        deliveryCity.val(invoiceCity.val());
    });

    deliveryPostCode.on('change paste keyup', function() {
        const postCode = deliveryPostCode.val();

        if (postCode === '' || postCode.length < 4) {
            errorDelivery.show();
        } else {
            errorDelivery.hide();
        }
    });

    shippingOptionsSelect.on('change', function() {
        var postCode = deliveryPostCode.val();

        if (postCode === '' || postCode.length < 4) {
            $(this).val('');
            errorDelivery.show();
            return false;
        }
        errorDelivery.hide();
        submit.attr('disabled', 'disabled');
        submit.addClass('blocked');

        homedeliveryCheckPrice(
            deliveryPostCode.val(),
            function(response) {
                if (response.data !== null || response.data.delivery_price === 0) {
                    recalculateDeliveryPrice(0);
                    submit.removeClass('blocked');
                    submit.removeAttr('disabled');
                }
                if (response.data.delivery_price >= 0) {
                    recalculateDeliveryPrice(response.data.delivery_price);
                    submit.removeClass('blocked');
                    submit.removeAttr('disabled');
                }
            },
            shippingOptionsSelect.data('haslongproduct'),
            shippingOptionsSelect.val(),
        );
    });

    openLoginModal.on('click', function(event) {
        event.preventDefault();
        $('.cart-login-modal').addClass('--visible');
    });

    closeLoginModal.on('click', function(event) {
        event.preventDefault();
        $('.cart-login-modal').removeClass('--visible');
    });

    openOfferModal.on('click', function(event) {
        event.preventDefault();
        $('.cart-offer-modal').addClass('--visible');
    });

    closeOfferModal.on('click', function(event) {
        event.preventDefault();
        $('.cart-offer-modal').removeClass('--visible');
    });

    $('.cart-product__edit-product-icon').click(function() {
        sessionStorage.setItem('edit-product-focus', $(this).data('product-id'));
    });

    $('.cart-product__salesman-discout-submit-button').click(function() {
        sessionStorage.setItem('edit-product-focus', $(this).data('product-id'));
    });

    if (sessionStorage.getItem('edit-product-focus')) {
        let focusOnProductId = sessionStorage.getItem('edit-product-focus');
        let productToFocus = $(`[data-product-id="${focusOnProductId}"]`);

        $('html, body').animate({
            scrollTop: productToFocus.offset().top
        });
        sessionStorage.removeItem('edit-product-focus');
    }

    $('#customer-type-private-button').on('click', function(event) {
        event.preventDefault();
        openPrivateCheckout();
    });

    $('#customer-type-company-button').on('click', function(event) {
        event.preventDefault();
        openCompanyCheckout();
    });

    $('#same-data-to-delivery-checkbox').on('click', function() {
        if ($('#same-data-to-delivery-checkbox').prop('checked')) {
            $('#delivery-data').hide(600);
        } else {
            $('#delivery-data').show(600);
        }
    });

    $('#code').on('keyup', function (){
        let start = this.selectionStart;
        let end = this.selectionEnd;
        this.value = this.value.toUpperCase();
        this.setSelectionRange(start, end);
    });

    function openPrivateCheckout() {
        $('#customer-type-private-form').show();
        $('#customer-type-company-form').hide();
        $('#customer-type-private-button').addClass('btn-primary');
        $('#customer-type-private-button').removeClass('btn-default');
        $('#customer-type-company-button').removeClass('btn-primary');
        $('#customer-type-company-button').addClass('btn-default');
    }

    function openCompanyCheckout() {
        $('#customer-type-company-form').show();
        $('#customer-type-private-form').hide();
        $('#customer-type-company-button').addClass('btn-primary');
        $('#customer-type-company-button').removeClass('btn-default');
        $('#customer-type-private-button').removeClass('btn-primary');
        $('#customer-type-private-button').addClass('btn-default');
    }
});

function submitSalesmanDiscount() {
    $('#salesmanCartDiscount').submit(function() {
        var formData = {};
        var submitButtonIcon = $(this).find('button i');
        submitButtonIcon
            .removeClass('fa-check')
            .addClass('fa-refresh fa-spin color-blue');

        $(this).serializeArray().forEach(function(item) {
            formData[item.name] = item.value;
        });
        $.ajax({
            url: apiUrl + '/update-discount',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(formData),
        }).done(function(response) {
            const data = response.data[0];
            const productElement = $('.cart-product__data[data-cart-product-id=' + data.item.id + ']');

            productElement.find('.cart-product__total-price .value').text(data.item.total_price);
            productElement.find('.cart-product__item-price .value').text(data.item.price);
            productElement.find('.cart-product__total-price .value-without-tax').text(data.item.total_price_without_tax);
            productElement.find('.cart-product__item-price .value-without-tax').text(data.item.price_without_tax);

            $('#summary-price__total_ordinary').attr('data-value', data.prices.total_ordinary[0]);
            $('#summary-price__total_ordinary').text(data.prices.total_ordinary[1]);
            $('#summary-price__discount').attr('data-value', data.prices.discount[0]);
            $('#summary-price__discount').text(data.prices.discount[1]);
            $('#summary-price__totalExShipping').attr('data-value', data.prices.ex_shipping[0]);
            $('#summary-price__totalExShipping').text(data.prices.ex_shipping[1]);
            $('#summary-price__shipping').attr('data-value', data.prices.shipping_ordinary[0]);
            $('#summary-price__shipping').text(data.prices.shipping_ordinary[1]);
            $('#summary-price__total').text(data.prices.totalWithShipping[1]);
            $('#summary-price__netprice').text(data.prices.totalNetPrice[1]);
            $('#summary-price__alltaxes').text(data.prices.allTaxes[1]);
            $('#summary-price__endcustomer_price').attr('data-value', data.prices.endCustomerPrice[0]);
            $('#summary-price__endcustomer_price').text(data.prices.endCustomerPrice[1]);

            submitButtonIcon
                .removeClass('fa-refresh fa-spin color-blue')
                .addClass('fa-check');
        }).fail(function() {
            submitButtonIcon
                .removeClass('fa-refresh fa-spin color-blue')
                .addClass('fa-ban red');

            setTimeout(function() {
                submitButtonIcon
                    .removeClass('fa-ban red')
                    .addClass('fa-check');
            }, 3000);
        });
        return false;
    });
};
var externalOrderNumberIsUnique = true;
var externalOrderNumberConfirmed = false;

$('#external-order-number').on('blur', function () {
    const val = $(this).val();

    if (val === '') {
        externalOrderNumberIsUnique = true;
        return;
    }
    $.ajax({
        url: apiUrl + '/is-external-order-number-unique',
        type: 'POST',
        dataType: 'json',
        data: { external_order_number: $(this).val() },
    }).done(function(response) {
        externalOrderNumberIsUnique = response.data[0] ?? true;
        if (!externalOrderNumberIsUnique) {
            externalOrderNumberConfirmed = false;
        }
        refreshExternalOrderNumberValidation();
    }).fail(function() {
        externalOrderNumberIsUnique = true;
        refreshExternalOrderNumberValidation();
    });
});

$('#external-order-number-validation').on('click', function() {
    externalOrderNumberConfirmed = true;
    refreshExternalOrderNumberValidation();
});

function refreshExternalOrderNumberValidation() {
    if (externalOrderNumberIsUnique) {
        $('#external-order-number-validation-error').hide();
        $('#existing-external-number-confirmation').modal('hide');
        $('#cart-manual-order-confirm-button button').prop('disabled', false);
    } else {
        $('#external-order-number-validation-error').show();

        if (externalOrderNumberConfirmed) {
            $('#existing-external-number-confirmation').modal('hide');
            $('#external-order-number-validation-error').addClass('text-success');
            $('#external-order-number-validation-error').removeClass('text-danger');
            $('#cart-manual-order-confirm-button button').prop('disabled', false);
        } else {
            $('#existing-external-number-confirmation').modal('show');
            $('#external-order-number-validation-error').addClass('text-danger');
            $('#external-order-number-validation-error').removeClass('text-success');
            $('#cart-manual-order-confirm-button button').prop('disabled', true);
        }
    }
}